// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cAp81","colMin":"styles_colMin__2zm08"};